import React from 'react';
import SaveIcon from "../components/SaveIcon"
import store from "../store"
import Cta from "../components/Cta";
import { getFontStyleFromFeed } from "../helperfunctions";
import { checkCorrectPlatform, formatItemDuration } from "../helperfunctions/common";
import { PLATFORM_WEB, PLATFORM_WEB_PREVIEW, PLATFORM_XBOX } from "../constants/common";
import { handleTextTruncate } from '../helperfunctions/ctvHelper';
import { getAllConstants } from '../helperfunctions/regionalization';

class DetailTitle extends React.Component {
  componentDidMount() {
    this.elm = document.querySelector('.summaryDescription');    
    handleTextTruncate(this.elm);
  }

  componentDidUpdate() {
    handleTextTruncate(this.elm);
  }

  render(){
    const { feeds, content, parent_content, summary, type, haveSavedMazIDFeed, secondary, showingSavedSection } = this.props;
    const { duration, rating, copyright, role, genre } = content;
    const fontStyle = getFontStyleFromFeed(feeds);
    const mainContent = (type === "menu") ? content : parent_content; // items or menu
    let isSpec = true;
    let isStarring = true;
    let isDirector= true;
    let isGenre = true;
    let descriptionLines = 5;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    if(!checkCorrectPlatform([PLATFORM_WEB, PLATFORM_WEB_PREVIEW])) {
      descriptionLines = 3;
      if(checkCorrectPlatform([PLATFORM_XBOX])) {
        descriptionLines = 2;
      }
      if(screenWidth >= 1366 ) descriptionLines = 4;
      if(screenWidth >= 1600 ) descriptionLines = 6;
      if(screenWidth >= 1920 ) descriptionLines = 7;
    } else {
      //web
      if(screenWidth >= 1440 ) descriptionLines = 9;
      if(screenWidth >= 1600 ) descriptionLines = 10;
      if(screenWidth >= 1920 ) descriptionLines = 13;
    }

    // let summary = {
    //   "title": "sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf",
    //   "subtitle": "sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf",
    //   "description": "sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf sakhfaksf askjfkasjf askdf",
    // }
    if(!mainContent.locked) {// Locked 
      descriptionLines++;
    }
    if(!duration && !rating && !copyright) {//spec not available
      isSpec = false;
      if(!summary.subtitle) {
        descriptionLines++;
      }
    }
    if(!role || !role.actor) {//actor not available
      isStarring = false;
      descriptionLines++;
    }
    if(!role || !role.director) {//Directors not available
      isDirector = false;
      descriptionLines++;
    }
    if(!genre) {//Generes not available
      isGenre = false;
      descriptionLines++;
    }

    // If screen height is too small, decrease description lines, If width is higher, decrease more.
    if (screenHeight < 700) {
      descriptionLines -= 2;
      if (screenWidth >= 1400) {
        descriptionLines--;
      }
    }
    const { kISGenres, kISGenre, kISDirector, kISDirectors, kISStarring } = getAllConstants();
    return(
      <div>
        {mainContent.locked && <Cta 
          interstitial={this.props.interstitial}
          interstitialProps={this.props.interstitialProps}
          layout={"detail"} 
          time={Date.now()} 
          detail={true} 
          store={store} 
          content={mainContent} 
          feeds={feeds} 
        />}
        <div className="summaryHolder" aria-live="polite" aria-atomic="true">
          <h4 style={fontStyle.primaryFont}>{summary.title}</h4>
          {isSpec 
            ?
              <div className="specs">
                {duration && <p style={fontStyle.secondaryFont}>{formatItemDuration(duration)}</p>}
                {copyright && <p style={fontStyle.secondaryFont}>{copyright}</p>}
                {rating && <p className='upperCase' style={fontStyle.secondaryFont}>{rating}</p>}
              </div>
            : <p className="subtitle" style={fontStyle.secondaryFont}>{summary.subtitle}</p>
          }
          <p className="summaryDescription breakSpaces" 
            style={{...fontStyle.secondaryFont, "WebkitLineClamp": descriptionLines}}
            id={`summaryDescription-${this.props.content.identifier}`}
          >
            {summary.description}
          </p>
          {isStarring && <div className="extra-specs">
            <p style={fontStyle.secondaryFont}>{kISStarring}</p>
            <p style={fontStyle.secondaryFont}>{role.actor}</p>
          </div>}
          {isDirector && <div className="extra-specs">
            <p style={fontStyle.secondaryFont}>{role.director.split(",").length > 1 ? kISDirectors : kISDirector}</p>
            <p style={fontStyle.secondaryFont}>{role.director}</p>
          </div>}
          {isGenre && <div className="extra-specs">
            <p style={fontStyle.secondaryFont}>{genre.split(",").length > 1 ? kISGenres : kISGenre}</p>
            <p style={fontStyle.secondaryFont}>{genre}</p>
          </div>}
        </div>
        {(feeds.hasSavedSection || haveSavedMazIDFeed) && type !== "menu" && type !== "fake" && (type !== "live" || showingSavedSection) &&
          <div className="saveIcon">
            <SaveIcon 
              locked={mainContent.locked} 
              store={store} 
              content={content} 
              type={"content"} 
              secondary={secondary} 
              feeds={feeds} 
              interstitialProps={this.props.interstitialProps}
              layout={'detail'}
              index={1}
              total={1}
            />
        </div>}
      </div>
    )
  }
}

export default DetailTitle;
